import api from './client'

export const menuPermisosApi = {
  mias: () => api.get('/menu-permisos/mias'),
  matriz: () => api.get('/menu-permisos'),
  guardar: (rol, items) => api.put('/menu-permisos', { rol, items }),
}

// Permisos por PERSONA (solo super administrador): un ítem restringido lo ven solo esas personas.
export const permisosPorPersonaApi = {
  listar: () => api.get('/menu-permisos/usuarios'),
  guardar: (item_key, usuario_ids) => api.put('/menu-permisos/usuarios', { item_key, usuario_ids }),
}
